module.exports = __webpack_public_path__ + "~@/assets/img/whatExif-4.14361823.png";